import { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import css from "./navbar.module.scss";
import logo from "../../images/bollenoord.png"
const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => setMenuOpen(prev => !prev);
    const closeMenu = () => setMenuOpen(false);

    return (
        <nav className={css.navbar}>
            <div className={css.content}>
                <div className={css.logo}>
                    <Link className={css.link} to="/" onClick={closeMenu}>
                        <img src={logo} alt={"Logo van Bollenoord"} className={css.logoImage} />
                    </Link>
                </div>

                <button
                    className={css.burger}
                    onClick={toggleMenu}
                    aria-label="Toggle menu"
                    aria-expanded={menuOpen}
                >
                    <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
                </button>

                <div className={`${css.list} ${menuOpen ? css.open : ""}`}>
                    <ul>
                        <li className={css.listItem}>
                            <Link className={css.link} to="/galerij" onClick={closeMenu}>Galerij</Link>
                        </li>
                        <li className={css.listItem}>
                            <Link className={css.link} to="/contact" onClick={closeMenu}>Contact</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
